declare const window: Window & { toastr: any; messages: any };

interface SourceDocument {
  id: number;
  fileName: string;
  hasText: boolean;
}

export function initAiFormFill(applicationId: number): void {
  const list = document.getElementById('ai-source-doc-list');
  const input = document.getElementById('ai-source-doc-input') as HTMLInputElement | null;
  const addButton = document.getElementById('ai-add-doc');
  const fillButton = document.getElementById('ai-fill-button') as HTMLButtonElement | null;
  if (!list || !input || !addButton || !fillButton) {
    return;
  }

  const base = `/api/application/${applicationId}/source-documents`;

  const render = (docs: SourceDocument[]): void => {
    list.innerHTML = '';
    docs.forEach((doc) => {
      const item = document.createElement('li');
      item.className = 'd-flex justify-content-between align-items-center small mb-1';
      const label = document.createElement('span');
      label.textContent = doc.fileName + (doc.hasText ? '' : ' ⚠');
      label.title = doc.hasText ? '' : (window.messages?.aiNoTextInFile ?? 'Geen leesbare tekst');
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'btn btn-link btn-sm text-danger p-0';
      remove.textContent = '×';
      remove.addEventListener('click', () => { void deleteDoc(doc.id); });
      item.appendChild(label);
      item.appendChild(remove);
      list.appendChild(item);
    });
  };

  const load = async (): Promise<void> => {
    const response = await fetch(base, { headers: { Accept: 'application/json' } });
    if (response.ok) {
      render(await response.json());
    }
  };

  const deleteDoc = async (docId: number): Promise<void> => {
    const response = await fetch(`${base}/${docId}`, { method: 'DELETE' });
    if (response.ok) {
      await load();
    }
  };

  const uploadFiles = async (files: FileList): Promise<void> => {
    for (let i = 0; i < files.length; i += 1) {
      const formData = new FormData();
      formData.append('file', files[i]);
      const response = await fetch(base, { method: 'POST', body: formData });
      if (!response.ok) {
        const body = await response.json().catch(() => ({ error: '' }));
        window.toastr.error(body.error || (window.messages?.couldNotSave ?? ''));
      }
    }
    await load();
  };

  addButton.addEventListener('click', () => input.click());
  input.addEventListener('change', () => {
    if (input.files && input.files.length > 0) {
      void uploadFiles(input.files).finally(() => { input.value = ''; });
    }
  });

  fillButton.addEventListener('click', async () => {
    fillButton.disabled = true;
    const original = fillButton.textContent;
    fillButton.textContent = '…';
    try {
      const response = await fetch(`/api/application/${applicationId}/ai-fill`, { method: 'POST' });
      const body = await response.json().catch(() => ({}));
      if (response.ok) {
        window.toastr.success((window.messages?.aiFilledFields ?? 'Velden ingevuld:') + ' ' + body.filledCount);
        window.location.reload();
      } else {
        window.toastr.error(body.error || (window.messages?.couldNotSave ?? ''));
        fillButton.disabled = false;
        fillButton.textContent = original;
      }
    } catch {
      window.toastr.error(window.messages?.couldNotSave ?? '');
      fillButton.disabled = false;
      fillButton.textContent = original;
    }
  });

  void load();
}
